import { sortByOrder } from "../utils/arrayHelper";

const useDragAndDrop = ({ state = [], stateSetter, onReordered }) => {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);

    result.splice(endIndex, 0, removed);

    const order = endIndex + 1;

    if (typeof onReordered === "function") {
      onReordered(removed, order);
    }

    return result
      .map((item, index) => {
        if (removed.id === item.id) {
          return {
            ...item,
            order: order,
          };
        }

        return {
          ...item,
          order: index + 1,
        };
      })
      .sort(sortByOrder);
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) return;

    const items = reorder(state, result.source.index, result.destination.index);

    if (typeof stateSetter === "function") {
      stateSetter(items);
    }
  };

  return {
    onDragEnd,
  };
};

export default useDragAndDrop;
